import { Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    CriteriaMutationResourceSchema,
    defaultCriteriaResource,
    useCriteriaActions,
} from '../../../../../resource/resources/artifacts/criteria/criteriaResource';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { CriteriaContent } from './CriteriaContent';

export const CriteriaView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const criteriaActions = useCriteriaActions();
    const criteriaQuery = criteriaActions.useGetResource(id);
    const updateCriteria = criteriaActions.useUpdateResource();
    const validateCriteria = criteriaActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: CriteriaMutationResourceSchema,
        defaultValues: defaultCriteriaResource,
        submitHandler: async (data) => {
            await updateCriteria.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: criteriaQuery.data,
    });

    return (
        <QueryBaseComponent name="Criteria" query={criteriaQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateCriteria.data}
                    metaDataInfo={criteriaQuery.data}
                    resourceType={ResourceType.CRITERIA}
                >
                    <Text c="dimmed">Criteria</Text>
                </ResourceValidationTitleBar>
                <CriteriaContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
